import React from 'react';

import { createStore, applyMiddleware, compose } from 'redux';

import rootReducer from './reducers';

import thunk from 'redux-thunk';



import {REHYDRATE} from 'redux-persist/constants'
import createActionBuffer from 'redux-action-buffer'
var store;

const middleware = [thunk, createActionBuffer(REHYDRATE)];

// if (process.env.NODE_ENV == 'development'){
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default function configureStore() {
    const store = createStore(rootReducer, undefined, composeEnhancers(
        applyMiddleware(...middleware),
        //migration
        //autoRehydrate({ log: true }) /* it is rehydrate all reducers, including blacklisted */
    ));
// } else { /* for production */
//     const createStoreWithMiddleware = applyMiddleware(
//         // promise,
//         thunk
//     )(createStore);
//     store = createStoreWithMiddleware(reducers)
// }
    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('./reducers', () => {
            const nextRootReducer = require('./reducers/index');
            store.replaceReducer(nextRootReducer);
        });
      module.hot.accept(function (err) {
        console.log('An error occurred while accepting new version');
      });
    }
 return store;
}
